import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const RouteAnnouncer = () => {
  const location = useLocation();
  const [announcement, setAnnouncement] = useState("");

  useEffect(() => {
    setAnnouncement(`Navigated to ${location.pathname}`);
  }, [location]);

  return (
    <div
      aria-live="polite"
      aria-atomic="true"
      style={{ position: "absolute", left: "-9999px" }}
    >
      {announcement}
    </div>
  );
};

export default RouteAnnouncer;
